import { FC } from "react"
import { DiscussionCategory } from "../../../../domain/entities/discussionCategory"
import { BlankStateSection } from "../../../shared/BlankStateSection"
import { CenteredSpinner } from "../../../shared/CenteredSpinner"
import { DiscussionCategoryListView } from "./DiscussionCategoryListView"

interface Props {
	list: DiscussionCategory[]
	isLoading: boolean
	onUpdate: (discussionCategory: DiscussionCategory) => void
	onDelete: (discussionCategory: DiscussionCategory) => void
	onAddClick: () => void
}

export const DiscussionCategoryListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return (
			<BlankStateSection
				message="No Discussion Categories found."
				onAddClick={onAddClick}
			/>
		)
	}

	return (
		<DiscussionCategoryListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
	)
}
